// The business-hours radio of BusinessHoursNew.vue (no business hours / copy from the Service Provider profile /
// own business hours) as plain logic, so it is testable without loading the component (Common.vue).

export const BUSINESS_HOURS_OPTION = Object.freeze({ NONE: 'NONE', COPY: 'COPY', NEW: 'NEW' } as const)
export type BusinessHoursOption = typeof BUSINESS_HOURS_OPTION[keyof typeof BUSINESS_HOURS_OPTION]

/**
 * AAL-86 Copilot: the option the entity stands for (copy on = COPY, own periods = NEW, none = NONE), or null
 * when the radio already shows it.
 */
export function optionFromModel(current: BusinessHoursOption, copyBusinessHours: boolean, businessHours: unknown[] | null | undefined): BusinessHoursOption | null {
	const option = copyBusinessHours ? BUSINESS_HOURS_OPTION.COPY : businessHours?.length ? BUSINESS_HOURS_OPTION.NEW : BUSINESS_HOURS_OPTION.NONE
	return option === current ? null : option
}

/**
 * The event a change of the radio to `option` emits to the page; null when the change was the one
 * `optionFromModel` set (`setFromModel`): the page already holds the entity that option was derived from.
 */
export function optionChangeEvent(option: BusinessHoursOption, setFromModel: BusinessHoursOption | null): string | null {
	if (option === setFromModel) return null
	if (option === BUSINESS_HOURS_OPTION.COPY) return 'copy-business-hours'
	if (option === BUSINESS_HOURS_OPTION.NEW) return 'new-business-hours'
	return 'no-business-hours'
}
